import {qs} from '@shared/helpers/queryString'
import {SchemasUniversalDelivery} from '@shared/schemas/universal'

import getApi, {createWrapper, getCommonBaseUrl} from '@web/helpers/api'
import {AddressBy} from '@web/slices/deliveryManager/slice'

const OrderManagerApiUrl = {
    /** 배송지 */
    delivery: '/delivery/address',
}

const api = getApi(getCommonBaseUrl())

/** 배송지 주문정보 요청 */
const getDelivery = ({orderNo, addressBy}: {orderNo: string; addressBy: AddressBy}) => {
    const url = OrderManagerApiUrl.delivery
    return createWrapper<SchemasUniversalDelivery['/delivery/address']['response']>(
        api.get(
            qs.stringifyUrl({
                url,
                query: {orderNo, addressBy},
            }),
        ),
    )
}

/** 배송지 변경 */
const changeDelivery = async ({
    orderNo,
    orderDeliveryAddress,
    uniqueMemo,
    memos,
    overseasDelivery,
    personalCustomsCode,
    addressBy,
}: SchemasUniversalDelivery['PUT/delivery/address']['request']) => {
    const url = OrderManagerApiUrl.delivery
    return createWrapper<SchemasUniversalDelivery['PUT/delivery/address']['response']>(
        api.put(url, {
            orderNo,
            orderDeliveryAddress,
            memos,
            uniqueMemo,
            overseasDelivery,
            personalCustomsCode,
            addressBy,
        }),
    )
}

export default {
    getDelivery,
    changeDelivery,
}
